module.exports = __webpack_public_path__ + "static/media/LifeLine4.de9d79c2.png";